import React, {Component, ReactNode} from 'react'
import AdminGeneralMeetingRepo, {GetConfirmationKeyNoticeDataResponse} from './AdminGeneralMeetingRepo'
import EventEmitterExAdmin from '../shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../shared/hoc/createAdminPage'
import {AdminPrimaryButton} from '../../styledComponents/adminPage/Buttons'
import NatPrintDialogComponent, {PRINT_TYPE,} from '../../__NoAutomatedTests/components/common/NatPrintDialogComponent'
import {Messages} from '../../Messages'
import {Nullable} from '../../app/TypeHelpers'
import {ConfirmationKeyNoticeData} from './model/ConfirmationKeyNoticeData'
import styled from 'styled-components'

interface Props {
    condominiumCd: string
    adminGeneralMeetingRepo: AdminGeneralMeetingRepo
    eventEmitter: EventEmitterExAdmin
}

interface State {
    confirmationKeyNoticeData: Nullable<ConfirmationKeyNoticeData>
    confirmationKeyIssueDialogOpen: boolean
}

class AdminUnitOwnerConfirmationKeyIssuePage extends Component<Props & AdminPagePropsSet, State> {
    constructor(props: Readonly<Props & AdminPagePropsSet>) {
        super(props)
        this.state = {
            confirmationKeyNoticeData: null,
            confirmationKeyIssueDialogOpen: false,
        }
    }

    handleConfirmationKeyIssueClick = async (): Promise<void> => {
        try {
            const response: Nullable<GetConfirmationKeyNoticeDataResponse> = await this.props.asyncCallFunction(
                this.props.adminGeneralMeetingRepo.getConfirmationKeyNoticeData.bind(
                    this.props.adminGeneralMeetingRepo,
                    this.props.condominiumCd,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (response === null || response.details === null) {
                this.props.navigate('/admin/error')
                return
            }

            this.setState({
                confirmationKeyNoticeData: response.details,
                confirmationKeyIssueDialogOpen: true,
            })
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleDialogClose = (): void => {
        this.setState({confirmationKeyIssueDialogOpen: false})
    }

    handlePrintExecute = async (): Promise<void> => {
        this.setState({confirmationKeyIssueDialogOpen: false})
    }

    render(): ReactNode {
        const {confirmationKeyNoticeData} = this.state

        return (
            <>
                <ConfirmationKeyIssueButton onClick={this.handleConfirmationKeyIssueClick}>
                    確認用キー発行
                </ConfirmationKeyIssueButton>
                <NatPrintDialogComponent
                    open={this.state.confirmationKeyIssueDialogOpen}
                    title={'区分所有者確認用キーの確認'}
                    errorLevel={Messages.IGMTA0007.errorLevel}
                    message={Messages.IGMTA0007.toString()}
                    printType={PRINT_TYPE.confirmationKeyNotice}
                    loginUserRoleId={null}
                    isWarn={false}
                    closeDiaLogHandler={this.handleDialogClose}
                    printExecuteHandler={this.handlePrintExecute}
                    confirmationKeyNoticeParams={{
                        confirmationKey: confirmationKeyNoticeData?.confirmationKey || '',
                        loginUrlWithConfirmationKey: confirmationKeyNoticeData?.loginUrlWithConfirmationKey || '',
                    }}
                />
            </>
        )
    }
}

export default createAdminPage(AdminUnitOwnerConfirmationKeyIssuePage)

const ConfirmationKeyIssueButton = styled(AdminPrimaryButton)`
  margin-top: 10px;
`
